<h2 class="form-title">Create User</h2>
<form [formGroup]="createUserForm" novalidate>
  <mat-form-field class="sport-input">
    <input matInput type="text" placeholder="Sport" formControlName="sport" id="sport">

    <mat-error *ngIf="submitted && hasError('sport', 'required')">{{ getErrorMessage('sport', 'required') }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput formControlName="userName" id="userName" type="text" placeholder="User Name">

    <mat-error *ngIf="submitted && hasError('userName', 'required')">{{getErrorMessage('userName',
      'required')}}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput formControlName="emailAddress" id="emailAddress" type="email" placeholder="Email Address">

    <mat-error *ngIf="submitted && hasError('emailAddress', 'required')">{{getErrorMessage('emailAddress',
      'required')}}</mat-error>

    <mat-error *ngIf="submitted && hasError('emailAddress', 'email') && !hasError('emailAddress', 'required')">{{getErrorMessage('emailAddress',
      'email')}}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput type="password" formControlName="password" id="password" placeholder="Password">

    <mat-hint>8-15 chars with 1 number and 1 special character (!&#64;#$%^&*()+=-_)</mat-hint>

    <mat-error *ngIf="submitted && hasError('password', 'required')">{{ getErrorMessage('password', 'required') }}</mat-error>

    <mat-error *ngIf="submitted && hasError('password', 'minlength')">{{ getErrorMessage('password', 'minlength') }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput type="password" formControlName="passwordConfirmation" id="passwordConfirmation" placeholder="Confirm Password">

    <mat-error *ngIf="submitted && hasError('passwordConfirmation', 'required')">{{getErrorMessage('passwordConfirmation',
      'required')}}</mat-error>

    <mat-error *ngIf="submitted && hasError('passwordConfirmation', 'nomatch') && !hasError('passwordConfirmation', 'required')">{{getErrorMessage('passwordConfirmation',
      'nomatch')}}</mat-error>
  </mat-form-field>

  <div class="birthday-selectors">
    <mat-form-field>
      <mat-select placeholder="Birth Month" formControlName="birthdayMonth">
        <mat-option *ngFor="let i of months; let idx = index" [value]="idx">
          {{ i }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="submitted && hasError('birthdayMonth', 'required')">{{ getErrorMessage('birthdayMonth', 'required') }}</mat-error>
    </mat-form-field>

    <span class="birthdate-divider"> / </span>

    <mat-form-field>
      <mat-select placeholder="Birth Year" formControlName="birthdayYear">
        <mat-option *ngFor="let i of years; let idx = index" [value]="getPastYear(idx)">
          {{ getPastYear(idx) }}
        </mat-option>
      </mat-select> 

      <mat-error *ngIf="submitted && hasError('birthdayYear', 'required')">{{ getErrorMessage('birthdayYear', 'required') }}</mat-error>
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-select placeholder="Please indicate your interest in the U.S. Army" formControlName="armyInterest" id="armyInterest">
      <mat-option *ngFor="let option of armyInterestOptions" [value]="option.selectionNumber">{{ option.value }}</mat-option>
    </mat-select>

    <mat-error *ngIf="submitted && hasError('armyInterest', 'required')">{{getErrorMessage('armyInterest',
      'required')}}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput type="tel" formControlName="phoneNumber" id="phoneNumber" placeholder="Phone Number" (keyup)="formatPhoneNumber($event)"
      [(ngModel)]="formattedPhone">

    <mat-error *ngIf="submitted && hasError('phoneNumber', 'required')">
      {{ getErrorMessage('phoneNumber', 'required') }}
    </mat-error>

    <mat-error *ngIf="submitted && hasError('phoneNumber', 'maxlength')">
      {{ getErrorMessage('phoneNumber', 'maxlength') }}
    </mat-error>

    <mat-error *ngIf="submitted && hasError('phoneNumber', 'minlength') && !hasError('phoneNumber', 'required')">{{getErrorMessage('phoneNumber',
      'minlength')}}</mat-error>
    <mat-error *ngIf="submitted && hasError('phoneNumber', 'invalidPhone') && !hasError('phoneNumber', 'required')">{{getErrorMessage('phoneNumber',
      'invalidPhone')}}</mat-error>
  </mat-form-field>

  <div class="email-option">
    <input type="checkbox" formControlName="emailOption" id="emailOption" ngModel>
    <label for="emailOption">I want to sign up for email updates</label>
  </div>

  <div class="buttons">
    <button type="submit" class="form-button" (click)="onSubmit()">Create User</button>
  </div>
</form>